'use strict';

import './modules/register-service-worker';
import $ from 'jquery';

// eslint-disable-next-line no-unused-vars
import './vendor/bootstrap/collapse';
import './vendor/bootstrap/transition';
import './vendor/iframeResizer';
import './vendor/jquery-huuPlugins';
import './complib/polyFillIncludes';
import './complib/polyfillStartsWith';
import legacy from './legacy';

// Core
import './jquery.fn';
import { create, boot } from './core';
import config from './config';

// A11y
import { selectorSupported } from './util/selectorSupported';

// Plugins
import navigation from './navigation';
import ui from './ui';
import club from './club';
import checkout from './checkout';

// Utils
import detectDevices from './util/detect-devices';
import { checkPages } from './util/track-pages';
import { tests as abTesting } from './util/ab-testing';
import clickable from './util/clickable';
import formValidation from './util/form-validation';
import { ajaxForm } from './util/ajax-form';
import filterConditionalFields from './util/form';
import linkEvents from './util/link';

// Misc
import plussa from './misc/plussa';
import masterpass from './misc/masterpass';
import gaEvents, { GoogleTagManager } from './misc/ga-events';
import redirectModal from './misc/redirect-modal';
import { OverlayInit } from './ui/overlays';


// Campaings
// TODO: pluginize
//import joker from './campaign/joker';
//import christmas2016 from './campaign/christmas2016';
//import viheltaen2017 from './campaign/viheltaen2017';

//=============================================================
// Constants
//=============================================================

config.breakpoints = { // TODO: Change everything to use ./ui/breakpoints.js
	mobile: 768,
	portrait: 768,
	horizontal: 1023,
	desktop: 1152
}

if (!selectorSupported(':focus-visible')) {
	document.body.classList.add('u-no-focus-visible');
}

//=============================================================
// API Registration
//=============================================================

const API = create('Site', config);

API.use(abTesting);
API.use(redirectModal);
API.use(OverlayInit);
API.use(navigation);
API.use(ui);
//API.use(product);
API.use(checkout);

API.use(club);
API.use(formValidation);
API.use(ajaxForm);
API.use(filterConditionalFields);

// Singular
API.use(plussa);
API.use(masterpass);
API.use(gaEvents);


API.use(legacy);

window.GoogleTagManager = GoogleTagManager;


//=============================================================
// API Boot
//=============================================================

if (document.getElementById('js-branch-bar')) {
	import('@crasman/branch-bar/styles.css');
	import('@crasman/branch-bar').then(({ branchBar }) => {
		branchBar.init();
	});
}

boot(API, () => {

	$.event.special.touchstart = {
		setup: function( _, ns, handle ) {
			this.addEventListener('touchstart', handle, { passive: !ns.includes('noPreventDefault') });
		}
	};
	$.event.special.touchmove = {
		setup: function( _, ns, handle ) {
			this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') });
		}
	};
	$.event.special.wheel = {
		setup: function( _, ns, handle ){
			this.addEventListener('wheel', handle, { passive: true });
		}
	};
	$.event.special.mousewheel = {
		setup: function( _, ns, handle ){
			this.addEventListener('mousewheel', handle, { passive: true });
		}
	};

	$(document).ready(() => {

		detectDevices();
		checkPages();
		clickable();
		linkEvents();

		if (document.querySelector('.v4-product-card') || document.querySelector('.product-list') || document.querySelector('.package-builder')) {
			import('./product').then(({ default: product }) => {
				console.log('API use product');
				API.use(product);
			});
		}

		if (document.querySelector('.product-review-box')) {
			import('./product/product-reviews').then(({ default: productReviews }) => {
				console.log('API use product reviews');
				API.use(productReviews);
			});
		}

		if (document.querySelector('#inspired-root')) {
			import('./inspired').then(({ default: Inspired }) => {
				API.use(Inspired);
			});
		}

		if (document.body.classList.contains('reclamation-page')) {
			import('./reclamation').then(({ default: Reclamation }) => {
				API.use(Reclamation);
			});
		}

		// Collection
		if (document.querySelector('.o-header .search-box-wrapper')) {
			import('./search/loop54-search-ui').then(({ default: Loop54SearchUi }) => {
				API.log('INIT Search');
				const loop54SearchUi = new Loop54SearchUi();
				loop54SearchUi.init();
			});
		}

		if (document.querySelector('.store-page') || document.querySelector('.store-search')) {
			import('./store').then(({ default: store }) => {
				API.use(store);
			});
		}

		API.log('INIT done');

		if ($('[data-slick]').length) {
			import('./vendor/slick-carousel').then(() => {
				$('[data-slick]').slick();
			});
		}

		const brandsCarouselSliders = document.querySelectorAll('.brands-carousel__slider');
		if (brandsCarouselSliders.length) {
			import('./ui/swiper-helper').then(({ initSlider }) => {
				brandsCarouselSliders.forEach((sliderEl) => {
					initSlider(sliderEl, {
						loop: true,
						speed: 500,
						autoplay: sliderEl.dataset.autoplay === '1' ? { delay: 2000, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
						// Matches the original (desktop-first) Slick tiers: <=480 -> 3, 481-600 -> 4, 601-1024 -> 6, >1024 -> 8.
						slidesPerView: 3,
						slidesPerGroup: 3,
						breakpoints: {
							480: {
								slidesPerView: 4,
								slidesPerGroup: 4
							},
							600: {
								slidesPerView: 6,
								slidesPerGroup: 4
							},
							1024: {
								slidesPerView: 8,
								slidesPerGroup: 4
							}
						}
					});
				});
			});
		}

		if ($('body').hasClass('vm-campaign') || $('body').hasClass('spring-cleaning')) {
			import('./campaign/viheltaen2017').then(({ default: viheltaen2017 }) => {
				viheltaen2017();
			});
		}

		if ($('.form-leasing').length) {
			import('./product/leasing').then(({ default: leasing }) => {
				leasing();
			});
		}

		if ($('.customer-service').length) {
			import('./content/customerService').then(({ default: customerService }) => {
				customerService();
			});
		}

		if(document.querySelector('[data-toggle-element]')) {
			import('./util/toggle-element').then(({ default: toggleElement }) => {
				toggleElement();
			});
		}

		if (document.querySelector('.cancel-order-form-page')) {
			import('./club/cancel-order-form').then(({ default: cancelOrderForm }) => {
				cancelOrderForm();
			});
		}

	});
});
